import { useSelector } from 'react-redux';
import { globalConfigurationSelector } from '../selectors/selectors';

export enum E_FEATURE_FLAGS {
    BUZZBRIDGE = 'features.buzzbridge',
    EVENTS = 'features.events',
    CAMPAIGNS = 'features.campaigns',
    AUDITIONS = 'features.audition',
    DISCOVER = 'features.discover',
    SUBSCRIPTIONS = 'features.account_features.subscriptions',
    TALENTS = 'features.talents',
    FEED = 'features.feed',
    INFLUENCER_PLATFORM_AVATAR_SEARCH = 'features.influencer_platform_avatar_search',
    UGC_ONLY = 'features.ugc_only',
}

// Utility to safely access a nested property via dot notation
function getValueByPath(obj: any, path: string): any {
    return path.split('.').reduce((acc, key) => acc?.[key], obj);
}

export const useFeatureFlag = (pathOrPaths: string[]): boolean[] => {
    const config = useSelector(globalConfigurationSelector);

    const check = (path: string) => {
        const value = getValueByPath(config, path);
        return value === 'active';
    };

    if (!config) {
        // Config not loaded yet — return default false(s)
        return Array.isArray(pathOrPaths) ? pathOrPaths.map(() => false) : [false];
    }

    return pathOrPaths.map(check);
};
